import React from 'react';
import { useDispatch } from 'react-redux';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import UnknownObject from 'types/UnknownObject';

import { trackButtonClicked } from '../../../Services/Analytics/TrackEventsService';

type ButtonClickEvent = React.MouseEvent<HTMLButtonElement, MouseEvent>;

type RestProps = {
  [key: string]: unknown;
};

type ITrackedButtonProps = RestProps & {
  onClick?: (event?: ButtonClickEvent) => void;
  trackingName: string;
  trackingProperties?: UnknownObject;
  buttonComponent?: React.ElementType;
};

const TrackedButton = ({
  onClick,
  trackingName,
  buttonComponent = Button,
  trackingProperties = {},
  ...rest
}: ITrackedButtonProps) => {
  const dispatch = useDispatch();
  const onTrackedButtonClick = (event: ButtonClickEvent) => {
    dispatch(trackButtonClicked(trackingName, trackingProperties));
    if (onClick !== undefined) {
      onClick(event);
    }
  };
  const ButtonComponent = buttonComponent;
  return <ButtonComponent data-testid="tracked-button" onClick={onTrackedButtonClick} {...rest} />;
};

export default TrackedButton;
